// extracted by mini-css-extract-plugin
module.exports =  {"growthMetricCards":"growthMetricCards_jd47QSsK","growthMetricCard":"growthMetricCard_pRn2WqcM"};